import { authApiClient } from '@/lib/api/lib/client'
import type { V1AuthUpdatePayload } from '@/lib/api/lib/models'
import { deviceTimezone } from '@/lib/date'

/**
 * Changes some profile fields; /auth/update leaves the others as they are.
 * Every update carries the device timezone (marketing quiet hours).
 */
export async function updateProfile(
    patch: V1AuthUpdatePayload,
    init?: RequestInit
): Promise<void> {
    await authApiClient.update(
        { v1AuthUpdatePayload: { ...patch, timezone: deviceTimezone() } },
        init
    )
}
